{
  "nl": {
    "dataProtection": {
      "copyright": "Houd rekening met auteursrechten wanneer je externe inhoud gebruikt",
      "data": "Deel nooit gevoelige of persoonlijke informatie met een AI-toepassing",
      "deletionPolicy": {
        "content": "Vanwege privacyvoorschriften worden alle inhoud van leerlingen na 365 dagen verwijderd."
      },
      "students": "Gebruik geen inhoud met persoonlijke gegevens van je leerlingen",
      "worksheets": "Geen zorgen: jouw werkbladen blijven behouden."
    }
  }
}
